import { render } from "./vhpTable.vue?vue&type=template&id=627eedc3"
import script from "./vhpTable.vue?vue&type=script&lang=js"
export * from "./vhpTable.vue?vue&type=script&lang=js"

import "./vhpTable.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__